import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { Trash2, MoreVertical, CornerUpRight, ArrowRight, MessageSquare, Edit2 } from 'feather-icons-react';
import { IUser } from 'src/services/types';

interface IProps {
    item: IUser; // Replace 'any' with the actual type of 'item'
    openNoteModal: (item: IUser) => void; // Replace 'any' with the actual type of 'item'
    onMoveAGroup: (item: IUser) => void; // Replace 'any' with the actual type of 'item'
    openEditUserModal: (item: IUser) => void; // Replace 'any' with the actual type of 'item'
    onDelete: (item: IUser) => void; // Replace 'any' with the actual type of 'item'
}
export const DropdownActionsUser = ({ 
    item, 
    openNoteModal, 
    onMoveAGroup, 
    openEditUserModal, 
    onDelete 
}: IProps) => {
  return (
    <UncontrolledDropdown
        className="me-2"
        direction="start"
    >
        <DropdownToggle
        caret
        className="btn btn-soft-info btn-sm waves-effect waves-light"
        >
        <MoreVertical size={'16px'}/>
        </DropdownToggle>
        <DropdownMenu>
            <DropdownItem onClick={() => openNoteModal(item)}>
                <div className="d-flex align-items-center gap-2">
                <MessageSquare size="16"/>
                <span>
                    {item?.note ? 'View notes' : 'Add note'}
                </span>
                </div>
            </DropdownItem>
            <DropdownItem divider style={{margin: '5px'}}/>
            <DropdownItem onClick={() => onMoveAGroup(item)}>
                <div className="d-flex align-items-center gap-2">
                {item?.group?.id ? <ArrowRight size="16"/> : <CornerUpRight size="16" />}
                <span>{item?.group?.id ? 'Change/remove group' : 'Assign group'}</span>
                </div>
            </DropdownItem>
            <DropdownItem divider style={{margin: '5px'}}/>
            <DropdownItem onClick={() => openEditUserModal(item)}>
                <div className="d-flex align-items-center gap-2">
                <Edit2 size="16"/>
                <span>Edit email / password</span>
                </div>
            </DropdownItem>
            <DropdownItem divider style={{margin: '5px'}}/>
            <DropdownItem onClick={() => onDelete(item)}>
                <div className="d-flex align-items-center gap-2">
                <Trash2 size="16"/>
                <span>Delete user</span>
                </div>
            </DropdownItem>
        </DropdownMenu>
    </UncontrolledDropdown>
  )
}